import { render } from "./ForgotPasswordEmail.vue?vue&type=template&id=0afd8591"
import script from "./ForgotPasswordEmail.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__

/* vue-cli-plugin-import-components */

import SignupMainContainer from "@/components/signup/SignupMainContainer.vue";
script.components = Object.assign({}, { SignupMainContainer }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { SignupMainContainer }, script.__o.components);}